import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";
import {
  FAQS,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION,
  BUYER_HOW_IT_WORKS,
  SELLER_HOW_IT_WORKS,
  MARKETPLACE_FAQS,
  ListingCheckoutTermsAndCondition,
  CreateListingTermsAndCondition,
} from "./helper";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const desktopBannerUrl =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Ohio+State/FB_2026StudentTickets_1920x450.jpg";
const mobileBannerUrl =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Ohio+State/FB_2026StudentTickets_375x550.jpg";

const TEAM_SCHEMA = "buckeyes_student";

export const buckeyes_student: TTeamConfig = {
  TEAM_SCHEMA: "buckeyes_student",
  TEAM_FULL_NAME: "Ohio State University",
  BROWSER_TITLE: "Ohio State Student Tickets",
  CLIENT_ID: "332b7a436b2b.seasonshare.buckeyes-buckeyes.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,
  MARKETPLACE_VENDOR: constants.vendorUUIDs.stripe,

  TEAM_GLOBAL_SETTINGS: {
    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/buckeyes/",
    COLORS_PRIMARY: "#ba0c2f",
    COLORS_SECONDARY: "#a7b1b7",
    DEFAULT_APP_ROUTE: routes.landing,
    IS_CROWD_HANDLER_ENABLED: true,
    IS_MARKETPLACE_ENABLED: true,
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    DISABLE_SIT_WITH_FRIENDS: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
      HIDE_PURCHASE_HISTORY: true,
    },

    IS_INTERCOM_ENABLED: true,
  },

  LANDING_PAGE_SETTINGS: {
    HIDE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,

    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
      SECTION_TITLE: "Student Tickets",
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    HIDE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,

    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <TERMS_AND_CONDITION />,
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  MARKETPLACE_GLOBAL_SETTINGS: {
    BUYER_HOW_IT_WORKS,
    SELLER_HOW_IT_WORKS,
    FAQS: MARKETPLACE_FAQS(TEAM_SCHEMA),
    MARKETPLACE_REDIRECT_WARN_MODAL_DESCRIPTION:
      "You’re entering a peer-to-peer marketplace where students can buy and sell tickets directly with each other. Prices are set by fellow students and are not regulated or controlled by Ohio State University.",
    STRIPE_KYC_CONFIRMATION_MODAL_DESCRIPTION:
      "Ohio State University and Attend use Stripe as a secure payment processor. You’re about to leave this page to complete seller onboarding, where we’ll collect your name, address, phone number, and bank details so we can deposit your payout once your ticket sells.",

    LISTING_CHECKOUT_TERMS_AND_CONDITION: <ListingCheckoutTermsAndCondition />,
    CREATE_LISTING_TERMS_AND_CONDITION: <CreateListingTermsAndCondition />,
  },

  MARKETPLACE_HOME_PAGE_SETTINGS: {
    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    BECOME_SELLER_CARD: {
      TITLE: "Sell Your Student Ticket",
      DESCRIPTION:
        "Got a student ticket you can’t use? Sell it to another student and make sure your seat is filled with school spirit. List your ticket in seconds and enjoy a quick, secure process that turns your unused ticket into extra cash.",
      BUTTON_TEXT: "Sell Your Ticket",
    },

    BECOME_BUYER_CARD: {
      TITLE: "Buy a Student Ticket",
      DESCRIPTION:
        "Looking for a ticket to the big game? Browse listings from fellow students and grab your seat in the student section. Enjoy a safe, hassle-free purchase and join your classmates in the action.",
      BUTTON_TEXT: "Browse Listings",
    },
  },

  MARKETPLACE_EVENTS_PAGE_SETTINGS: {
    PAGE_INFO_TEXT:
      "Click on a game to browse the available student tickets. After purchasing another student's ticket, your ticket with seat locations will be delivered the day before the game.",
    CART: {
      MAX_LISTINGS_COUNT: 4,
    },
  },

  MARKETPLACE_THANK_YOU_PAGE_SETTINGS: {
    DESCRIPTION:
      "Your Ohio State University student ticket will be delivered within 2 hours of purchase in your Buckeyes Student Account Manager.",
  },

  MARKETPLACE_CREATE_LISTING_PAGE_SETTINGS: {
    PAGE_INFO_TEXT:
      "List your student tickets for upcoming games and check back here to track their status — only student tickets can be listed. Listings for each game will close before gameday, at which point any unsold tickets will be removed and your ticket with seat locations will be delivered the day before the game.",
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NCAA/Ohio-State-Buckeyes.png",
    LANDING_PAGE_STATIC_BANNER_URL: desktopBannerUrl,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: mobileBannerUrl,
    GROUP_INVITE_PAGE_STATIC_BANNER_URL: desktopBannerUrl,
    ORDER_SUMMERY_BACKGROUND_URL: desktopBannerUrl,
    MARKETPLACE_HOME_PAGE_STATIC_BANNER_URL: desktopBannerUrl,
  },

  LANGUAGES: {
    FAQS,
  },
};
